"use strict";import{tag as t}from"../custom-tag.js";export function ciscoUPulseIcon({height:l=16,width:e=16,hidden:r=!1,title:i="Cisco u pulse"}={}){return t`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${i}"
    >
      <g
        fill="currentColor"
        clip-path="url(#cisco-u-pulse_svg__clip0_3137_72361)"
      >
        <circle cx="21.3" cy="21.6" r="2.1" />
        <path
          fill-rule="evenodd"
          d="M19.2 0H.3v5.156A26.2 26.2 0 0 1 10 3.35c3.168-.017 6.281.54 9.2 1.616zm0 5.928A25.3 25.3 0 0 0 10 4.25 25.3 25.3 0 0 0 .3 6.126v8.49a17.85 17.85 0 0 1 18.9-.313zM4.215 22.21a9.44 9.44 0 0 1-3.851-6.555 16.95 16.95 0 0 1 18.803-.313 9.44 9.44 0 0 1-3.626 6.675 9.15 9.15 0 0 0-11.326.193m.797.518A9.4 9.4 0 0 0 9.75 24c1.84 0 3.559-.526 5.012-1.437a8.25 8.25 0 0 0-9.75.166"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  `}
//# sourceMappingURL=ciscoUPulse.js.map
